export const DEDUPLICATION_MAP_ID = 'deduplication-map';

/**
 * Color constants for deduplication QA.
 *
 * Obtained from the IBM color-blind safe palette:
 * https://www.color-hex.com/color-palette/1044488
 *
 * NOTE: These colors match the `cyvl-dedup` package in the spatial repo,
 * adapted slightly though so we have stroke and fill colors.
 */
export const YELLOW_FILL = 'rgba(255, 176, 0, 0.4)';
export const YELLOW_STROKE = 'rgba(255, 176, 0, 0.8)';
export const ORANGE_FILL = 'rgba(254, 97, 0, 0.4)';
export const ORANGE_STROKE = 'rgba(254, 97, 0, 0.8)';
export const MAGENTA_FILL = 'rgba(220, 38, 127, 0.4)';
export const MAGENTA_STROKE = 'rgba(220, 38, 127, 0.8)';
export const PURPLE_FILL = 'rgba(120, 94, 240, 0.4)';
export const PURPLE_STROKE = 'rgba(120, 94, 240, 0.8)';
export const BLUE_FILL = 'rgba(100, 143, 255, 0.4)';
export const BLUE_STROKE = 'rgba(100, 143, 255, 0.8)';